'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _configProvider = require('./utils/configProvider');

var _configProvider2 = _interopRequireDefault(_configProvider);

var _events = require('./events');

var _traits = require('./traits');

var _logIn = require('./events/logIn');

var _logIn2 = _interopRequireDefault(_logIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    _configProvider2.default.registerEvent(_logIn2.default);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SIGN_IN);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SUBSCRIBE);

    _configProvider2.default.registerEvent(_events.EVENT_BETTING_OFFER_CLICK, function () {
        return (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes2.default.string.isRequired);
    }, function (props) {
        return (0, _extends3.default)({}, props);
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/registerEvents.js
// module id = 1223
// module chunks = 0